import React from "react";

import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function Loader() {
  return (
    <div className={styles.loader}>
      <Skeleton className={styles.item} />
      <Skeleton className={styles.item} />
      <Skeleton className={styles.item} />
    </div>
  );
}

export { Loader };
